export default __webpack_public_path__ + "static/media/house.d913d8b9.svg";